import Checkbox from "../Checkbox";
import style from "./style.module.scss";

export default function Checkbox2(props) {
  const { checked, onChange, label } = props;
  return (
    <label className={style.checkbox}>
      <Checkbox checked={checked} onChange={onChange} />
      <span className={style.label}>{label}</span>
    </label>
  );
}
